exports.install = function (Vue, axios) {
  if (this.installed) {
    return
  }

  this.installed = true

  // axios.defaults.baseURL = process.env.SETTINGS.API_URL
  axios.defaults.baseURL = '//www.payeasy.com.tw/TravelShop/'
  axios.withCredentials = true
  axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'
  axios.defaults.xsrfCookieName = 'XSRF-TOKEN-TRAVEL-SHOP'
  axios.defaults.headers.common['Content-Type'] = 'application/json'
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

  let PROTECTION_PREFIX = /^\)\]\}',?\n/

  axios.defaults.transformResponse = [function (data) {
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '')
    }

    try {
      data = JSON.parse(data)
    } catch (e) {
      /* Ignore */
    }

    return data
  }]

  Vue.axios = axios

  Object.defineProperty(Vue.prototype, '$axios', {
    get: function get () { return axios }
  })
}



// WEBPACK FOOTER //
// ./src/configs/axios/plugin.js